/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostOptimizationViewRecommendationRequest {
    getFixupPrototypeFunction() { return CostOptimizationViewRecommendationRequest.fixupPrototype; }

    static newInstance(model: Partial<CostOptimizationViewRecommendationRequest>): CostOptimizationViewRecommendationRequest {
        let obj = Object.assign(new CostOptimizationViewRecommendationRequest(), model);
        CostOptimizationViewRecommendationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostOptimizationViewRecommendationRequest>): CostOptimizationViewRecommendationRequest {
        if (!model) return null;
        return CostOptimizationViewRecommendationRequest.newInstance(<CostOptimizationViewRecommendationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostOptimizationViewRecommendationRequest) {
        if (!obj) return;

        models.CostOptimizationViewRecommendationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostOptimizationViewRecommendationRequest): boolean {
        Object.setPrototypeOf(obj, CostOptimizationViewRecommendationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.page === undefined) {
            this.page = 0;
        }
        if (this.limit === undefined) {
            this.limit = 0;
        }
    }

    /**
     * page number.Example 'page': 1
     */
    page: number;

    /**
     * records limits.Example 'limit': 10
     */
    limit: number;

    /**
     * Cloud account id
     */
    cloud_account_id: string;

    /**
     * currency type
     */
    currency: string;

}
